import { useAuth0 } from "@auth0/auth0-react";
import { Checkbox, TableContainer } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import Paper from "@mui/material/Paper";
import FinanceService from "Lib/API/Finance";
import { ReactComponent as PayNowSvg } from "assets/icons/Property.svg";
import { ReactComponent as SortAbleSvg } from "assets/icons/sort-able-svg.svg";
import { MyCheckbox } from "components";
import MyButton from "components/MyButton";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import { findIndex } from "lodash";
import React, { memo, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import FinanceDrawer from "../Drawer";
import AccountSelectionTableData from "./AccountSelectionTableData";

const AccountSelectionTable = ({
  formik,
  setPage,
  sortCharged,
  count,
  page,
  productData,
  loading,
  selectedData,
  onCheckboxClick,
  setSelected,
  selected,
  setCheckPage,
  checkPage,
}) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [selectionModel /* setSelectionModel */] = React.useState([]);
  const [drawerData, setDrawerData] = useState({});
  const [currentAccount, setCurrentAccount] = useState(null);
  const [check, setCheck] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const onCheckboxChange = (e) => {
    const { checked } = e.target;
    if (checked) {
      setSelected((prev) => {
        return [...prev, ...productData?.map((item) => ({
          id: item._id,
          name: item?.name ?? item?.family_name,
          amount: item?.payment?.balance,
        }))];
      });
    } else {
        // remove all productData from selected
        setSelected((prev) => {
          return prev.filter((item) => {
            return findIndex(productData, { _id: item.id }) === -1;
          });
        });
    }

    if (checkPage.includes(page)) {
      let newChecks = checkPage.filter((item) => {
        return item !== page;
      });
      setCheckPage(newChecks);
    } else {
      setCheckPage((prev) => [...prev, page]);
    }
  };
  // const onPayNowClick = (row) => {
  //   document.dispatchEvent(new CustomEvent("pay-now", { detail: row }));
  // };

  // const onReversalClick = async (id, setReversalActionTypes) => {
  //   const token = await getAccessTokenSilently();
  //   await FinanceService.reverseCharge(id, token)
  //     .then(() => {
  //       toastr.success("Success", "Charge has been reversed");
  //     })
  //     .catch((e) => {
  //       toastr.error(
  //         "Reversal Error",
  //         e?.response?.data?.message ?? "An Error occured, try again later"
  //       );
  //     });
  //   fetchMyAPI();
  //   setReversalActionTypes(false);
  // };

  const modifyRowData = (row, item) => {
    const modified = { ...row, charge: { ...row.charge }, ...item };
    setDrawerData(modified);
    setOpenModal(true);
  };

  const handleChangePage = (_, newPage) => {
    // if (newPage < 1) {
    //   setPage(1);
    // } else {
    setPage(newPage);
    // }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 50));
    setPage(0);
  };

  return (
    <div className="w-100">
      <div className="family-table-container pl-13 pr-2 pb-15 pr-13">
        <div className="home-table-container mt-0 no-box-shadow">
          <div className="d-flex justify-content-between mb-7 h-40px">
            <div className="yah-sub">
              {selected.length} Accounts selected
            </div>
            {selectionModel.length > 0 && (
              <MyButton
                buttonTextStyle={{ margin: 0 }}
                content={
                  <>
                    <PayNowSvg /> <span className="">Pay All</span>
                  </>
                }
              />
            )}
          </div>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <MyCheckbox
                      handlechange={onCheckboxChange}
                      checked={!!checkPage?.includes(page)}
                    />
                  </TableCell>

                  <TableCell
                    className="selection-account-name"
                    align="left"
                    onClick={() => sortCharged("name")}
                  >
                    <span>{"Account Name".toUpperCase()}</span>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="selection-account-balance"
                  // onClick={() => sortCharged("charged")}
                  >
                    <span>{"Account balance".toUpperCase()}</span>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="selection-account-billing"
                  // onClick={() => sortCharged("total_paid")}
                  >
                    <span>{"billing type".toUpperCase()}</span>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="selection-account-ledger"
                  // onClick={() => sortCharged("ledger")}
                  >
                    <span>{"previous payment date".toUpperCase()}</span>
                  </TableCell>
                  <TableCell align="left" />
                </TableRow>
              </TableHead>

              {loading && (
                <div className="tran-loader">
                  <Loader />
                </div>
              )}

              {productData?.length === 0 ? (
                <td colSpan={12}>
                  <div className="record-text">No record found</div>
                </td>
              ) : (
                productData?.map((row) => (
                  <TableBody>
                    <AccountSelectionTableData
                      key={row.name}
                      row={row}
                      check={check}
                      // onPayNowClick={onPayNowClick}
                      // onReversalClick={onReversalClick}
                      setDrawerData={setDrawerData}
                      setOpenModal={setOpenModal}
                      selectedData={selectedData}
                      onCheckboxClick={onCheckboxClick}
                      formik={formik}
                    />
                  </TableBody>
                ))
              )}
            </Table>
          </TableContainer>
          {productData?.length === 0 ? (
            ""
          ) : (
            <div className="pagination-custom mt-2">
              <Pagination
                count={Math.ceil(count / 50)}
                color="primary"
                variant="outlined"
                onChange={(event, value) => {
                  setPage(value - 1);
                }}
              />
            </div>
          )}
        </div>
        <RightDrawer
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <FinanceDrawer
            data={drawerData}
            handleClose={() => setOpenModal(false)}
          // onReversalClick={onReversalClick}
          />
        </RightDrawer>
      </div>
    </div>
  );
};

export default memo(AccountSelectionTable);
